import { cn } from "@/lib/utils";

export type WizardStep = {
  id: string;
  label: string;
};

interface WizardStepIndicatorProps {
  steps: WizardStep[];
  currentStepId: string;
  className?: string;
}

export const WizardStepIndicator = ({
  steps,
  currentStepId,
  className,
}: WizardStepIndicatorProps) => {
  const currentIndex = steps.findIndex((step) => step.id === currentStepId);

  return (
    <nav aria-label="Wizard progress" className={cn("w-full", className)}>
      <ol className="flex w-full items-start">
        {steps.map((step, index) => {
          const isComplete = index < currentIndex;
          const isCurrent = index === currentIndex;

          return (
            <li
              key={step.id}
              className="relative flex min-w-0 flex-1 flex-col items-center"
            >
              {index < steps.length - 1 && (
                <div
                  aria-hidden
                  className={cn(
                    "absolute left-1/2 top-3.5 h-0.5 w-full sm:top-4",
                    index < currentIndex ? "bg-primary" : "bg-muted",
                  )}
                />
              )}
              <div
                className={cn(
                  "relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors sm:h-8 sm:w-8 sm:text-sm",
                  isComplete && "bg-primary text-primary-foreground",
                  isCurrent &&
                    "bg-background text-primary ring-2 ring-primary",
                  !isComplete &&
                    !isCurrent &&
                    "bg-muted text-muted-foreground",
                )}
                aria-current={isCurrent ? "step" : undefined}
              >
                {isComplete ? "✓" : index + 1}
              </div>
              <span
                className={cn(
                  "mt-1 w-full px-0.5 text-center text-[10px] leading-tight sm:text-xs",
                  isCurrent
                    ? "font-medium text-primary"
                    : "text-muted-foreground",
                )}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
